import { AppUtil } from 'kuaidong-lib'
import { receivePrizeRes } from 'kuaidong-model'

export class APrize {
  public static async addPrize(prizeRecordId: string): Promise<receivePrizeRes> {
    return AppUtil.httpPOST('/web/lucky_draw/prize', {
      prize_record_id: prizeRecordId,
    })
  }
}
